import { Component, Input } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";

@Component({
    selector: 'instrutor-etapa2',
    templateUrl: './instrutor-etapa2.component.html',
})
export class CrudInstrutorEtapa2Component extends BaseStepComponent {

    @Input() listaCursos: SelectItem[] = []
    @Input() uploadedFiles: any[] = [];
    @Input() listaFormacaoAcademico: any[] = [];
    @Input() listaFormacaoInstrutor: any [] = [];


    init() {
    }

}


// WEBPACK FOOTER //
// ./src/app/instrutor/crud/etapas/instrutor-etapa2.component.ts